export default __webpack_public_path__ + "static/media/woodblock.26c49759.mp3";